import MenuListTasks from "../MenuListTasks/MenuListTasks";

/**
 * A component that renders a calendar event using the `MenuListTasks` component.
 * It is designed to display event details within the calendar and integrates with the `react-big-calendar` library.
 * 
 * @component
 * @param {Object} props - The component props.
 * @param {Object} props.event - The event object containing details to be displayed.
 * @param {string} props.event.type - The type of the event.
 * @param {string|number} props.event.id - The unique identifier of the event.
 * @returns {JSX.Element} The rendered calendar event component.
 * @example
 * <CalendarEvent event={{ type: "task", id: 1, title: "Sample Task" }} />
 */
const CalendarEvent = ({ event }) => {
  return (
    <MenuListTasks item={event} tagType="calendar" key={event.type + "_calendar" + event.id} />
  );
};

export default CalendarEvent;
